import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';
import type { GetTasksPayload, TasksSliceState } from '@/domains/tasks/store/types';
import type { GetTasksResponse } from '@/domains/tasks/types/api/responses/GetTasksResponse';

const initialState: TasksSliceState = {
  data: {
    listings: [],
    pagination: {
      numberOfItems: 0,
      first: '1',
      last: undefined,
      previous: '0',
      next: '0',
      page: 1,
      perPage: 20,
    },
  },
  statuses: {
    isLoading: false,
  },
};

export const tasksSlice = createSlice({
  name: 'newTasksSlice',
  initialState,
  reducers: {
    getTasks: (state, _action: PayloadAction<GetTasksPayload>) => {
      state.statuses.isLoading = true;
      state.data.pagination = initialState.data.pagination;
    },
    getTasksFailed: (state) => {
      state.statuses.isLoading = false;
    },
    getTasksSuccess: (
      state,
      { payload: { shouldRewrite = true, data } }: PayloadAction<{ shouldRewrite?: boolean; data: GetTasksResponse }>,
    ) => {
      const listingsArray = Array.isArray(data.listings) ? data.listings : [data.listings];
      if (shouldRewrite) {
        state.data.listings = [...listingsArray];
      } else {
        state.data.listings = [...state.data.listings, ...listingsArray];
      }

      state.data.pagination = data.pagination;
      state.statuses.isLoading = false;
    },
    incrementTasksPage: (state, _action: PayloadAction<GetTasksPayload>) => {
      state.data.pagination.page++;
    },
    resetTasksSlice: () => initialState,
  },
});

export const { getTasks, getTasksSuccess, getTasksFailed, incrementTasksPage, resetTasksSlice } = tasksSlice.actions;

export const tasksSliceReducerPath = tasksSlice.reducerPath;
export const tasksSliceReducer = tasksSlice.reducer;
